var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer_container"},[_c('div',{staticClass:"left"},[_vm._v("\n    ©2021-2023 上海丞乐网络科技有限公司版本所有\n  ")]),_c('div',{staticClass:"right",on:{"click":_vm.toOpen}},[_vm._v("\n    沪ICP备18026676号\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }